import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import {
  EmproSpinnerComponent,
  EmproSpinnerService,
} from '@empro-crm/shared-ui';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, EmproSpinnerComponent],
})
export class AppComponent {
  constructor(public emproSpinnerService: EmproSpinnerService) {}
}
